import { DomainRule } from '../types';

export const CampaignNameRequiredRuleKey = 'campaignNameRequired';
export const CampaignNameCharLimitRuleKey = 'campaignNameCharLimit';

/**
 * A campaign name is required to allow the user to identify the campaign they've
 * created.
 * @param name Name of the campaign
 * @returns 'fail', with an error message, if the name is empty, null or whitespace. 'pass' a name is set.
 */
export const CampaignNameRequiredRule = ({ name }: { name: string }): DomainRule => {
  const trimmedName = name?.trim();
  if (!trimmedName) {
    return {
      result: 'fail',
      ruleKey: 'campaignNameRequired',
    };
  }

  if (trimmedName.length < 5 || trimmedName.length > 100) {
    return {
      result: 'fail',
      ruleKey: 'campaignNameCharLimit',
    };
  }

  return {
    result: 'pass',
    ruleKey: null,
  };
};
